import WarningIcon from '@mui/icons-material/Warning';
import { Drawer, List, ListItemIcon, styled } from '@mui/material';
import { Link } from 'react-router-dom';

import { LAYOUT_WIDTH } from '../../layouts/constants';

const openedMixin = (theme) => ({
  width: LAYOUT_WIDTH.MAX,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: LAYOUT_WIDTH.MIN,
});

export const StyledDrawer = styled(Drawer)(({ open, theme }) => ({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  width: open ? LAYOUT_WIDTH.MAX : LAYOUT_WIDTH.MIN,
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export const StyledMainList = styled(List)(({ theme }) => ({
  flexGrow: theme.spacing(1),
  marginBottom: LAYOUT_WIDTH.MIN / 2 + 1,
  overflow: 'auto',
  overflowX: 'hidden',
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.grey[700],
}));

export const StyledSidebarIcon = styled(ListItemIcon)(({ open, theme }) => ({
  paddingLeft: open ? 0 : 2,
  minWidth: open ? theme.spacing(4.5) : theme.spacing(5.5),
  transition: theme.transitions.create(['min-width', 'padding'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.shorter,
  }),
}));

export const StyledWarningIcon = styled(WarningIcon)(({ open, theme }) => ({
  color: theme.palette.warning.main,
  marginTop: theme.spacing(0.5),
  borderRadius: open ? 0 : '50%',
  backgroundColor: open ? 'initial' : theme.palette.common.white,
  fontSize: open ? '1.5rem' : '1rem',
  transition: theme.transitions.create(
    ['font-size', 'background-color', 'border-radius'],
    {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }
  ),
}));

export const StyledListFooter = styled(List)(({ open, theme }) => ({
  // bottom fixed position
  position: 'fixed',
  bottom: 0,
  overflow: 'hidden',
  padding: 0,
  // width transition css
  flexShrink: 0,
  whiteSpace: 'nowrap',
  width: open ? LAYOUT_WIDTH.MAX : LAYOUT_WIDTH.MIN,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.shorter,
  }),
}));
